import _ from 'lodash';
import * as moment from 'moment';
import { Validators } from '@angular/forms';

import { CampaignSchema } from './campaign';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

export const HinduTemplePujaPresetOptionSchema = {
    'fields': [{
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value)
        }
    }, {
        'field': 'valueProvided',
        'value': 0,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
      'field': 'additionalInfoRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
      }
    }, {
      'field': 'additionalInfoDetail',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || ''
      }
    }, {
      'field': 'additionalInfoDesc',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || '',
        'validators': (data) => {
            return data.additionalInfoRequired ? [Validators.required] : [];
        }
      }
    }, {
        'field': 'additionalInfoSelectRequired',
        'value': false,
        'validators': [],
        'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
            }
        }
    }, {
        'field': 'additionalInfoSelect',
        'value': [],
        'validators': [],
        'options': {
            'setter': (data, value) => value || [],
            'validators': (data) => {
                return data.additionalInfoSelectRequired ? [Validators.required] : [];
            }
        }
    }, {
        'field': 'additionalInfoSelectDesc',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data) => {
                return data.additionalInfoSelectRequired ? [Validators.required] : [];
            }
        }
    }, {
        'field': 'deityRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'recurrence',
        'value': 0,
        'validators': [Validators.required]
    }, {
        'field': 'optionDay',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data) => {
                if(data.dateRequired) {
                    return 2;
                }
                const unix = parseInt(moment(data.pujaDate).format('X'));
                if(unix <= 978300000) {
                    return 0;
                }
                return 1;
            },
            'validators': (data) => {
                return data.recurrence === 0 ? [Validators.required]: [];
            }
        }
    }, {
        'field': 'weekDay',
        'value': 0,
        'validators': [Validators.required]
    }, {
        'field': 'dateOfMonth',
        'value': () => moment().format(),
        'validators': [Validators.required],
        'options': {
            'getter': (control, {
                controls: { recurrence: { value: recurrence }}
            }) => {
                const D = moment(control.value).format('D');
                return (recurrence === 3) ? parseInt(D): 0;
            },
            'setter': (data, value) => {
                return _.isDate(value) ?
                    moment(value).format("MM/DD/YYYY"):
                    moment().date(value).format("MM/DD/YYYY");
            }
        }
    }, {
        'field': 'hinduDates',
        'value': {},
        'valudators': [],
        'options': {
            'getter': (control, {
                controls: {recurrence, hinduDatePaksha: { value: paksha }, hinduDateTithi: { value: tithi } }
            }) => {
                switch(recurrence.value) {
                    case 4:
                        return { paksha, tithi };
                    case 5:
                        return { tithi };
                }
                return {};
            }
        }
    }, {
        'field': 'hinduDatePaksha',
        'value': 1,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                return _.get(data, 'hinduDates.paksha', 1);
            }
        }
    }, {
        'field': 'hinduDateTithi',
        'value': 1,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                return _.get(data, 'hinduDates.tithi', 1);
            }
        }
    }, {
        'field': 'pujaMultiDates',
        'value': [],
        'validators': [],
        'options': {
            'getter': (control) => {
                return _.map(control.value, value => {
                    return moment(value).format('YYYY/MM/DD')
                });
            },
            'setter': (data, value) => {
                return _.map(data.pujaMultiDatesUnix, value => {
                    return moment.unix(value).format("MM/DD/YYYY");;
                });
            }
        }
    }, {
        'field': 'pujaMultiDatesUnix',
        'value': [],
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const pujaMultiDates = form.get("pujaMultiDates");
                return _.map(pujaMultiDates.value, value => {
                    return moment(value).unix();
                });
            }
        }
    }, {
        'field': 'dateRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'pujaDate',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                return _.isEmpty(control.value) ?
                    moment(978300000000).format('YYYY/MM/DD'):
                    moment(control.value).format('YYYY/MM/DD');
            },
            'setter': (data, value) => {
                if(data.dateRequired) {
                    return '';
                }
                if(!value) {
                    return '';
                }
                return moment.unix(data.pujaDateUnix).format("MM/DD/YYYY");
            }
        }
    }, {
        'field': 'pujaDateUnix',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const pujaDate = form.get("pujaDate");
                return _.isEmpty(pujaDate.value) ? 978300000000: moment(pujaDate.value).unix();
            }
        }
    }, {
        'field': 'offeredFor',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                switch(data.recurrence) {
                    case 0:
                      return false;
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        return true;
                    case 6:
                        return false;
                }
                return false;
            }
        }
    }, {
        'field': 'pujaPeriods',
        'value': [],
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const periods = []
                const weekCheckbox = form.get('offeredForWeekCheckbox');
                if(weekCheckbox.value) {
                    const weekInput = form.get('offeredForWeekInput');
                    periods.push({ period: 1, amount: parseFloat(weekInput.value) });
                }
                const monthCheckbox = form.get('offeredForMonthCheckbox');
                if(monthCheckbox.value) {
                    const monthInput = form.get('offeredForMonthInput');
                    periods.push({ period: 2, amount: parseFloat(monthInput.value) });
                }
                const halfYearCheckbox = form.get('offeredForHalfYearCheckbox');
                if(halfYearCheckbox.value) {
                    const halfYearInput = form.get('offeredForHalfYearInput');
                    periods.push({ period: 4, amount: parseFloat(halfYearInput.value) });
                }
                const yearCheckbox = form.get('offeredForYearCheckbox');
                if(yearCheckbox.value) {
                    const yearInput = form.get('offeredForYearInput');
                    periods.push({ period: 3, amount: parseFloat(yearInput.value) });
                }
                return periods;
            }
        }
    }, {
        'field': 'offeredForWeekCheckbox',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 1 }) || null;
                return !_.isNull(period);
            }
        }
    }, {
        'field': 'offeredForWeekInput',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 1 }) || null;
                return _.isNull(period) ? 0: period.amount;
            }
        }
    }, {
        'field': 'offeredForMonthCheckbox',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 2 }) || null;
                return !_.isNull(period);
            }
        }
    }, {
        'field': 'offeredForMonthInput',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 2 }) || null;
                return _.isNull(period) ? 0: period.amount;
            }
        }
    }, {
        'field': 'offeredForHalfYearCheckbox',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 4 }) || null;
                return !_.isNull(period);
            }
        }
    }, {
        'field': 'offeredForHalfYearInput',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 4 }) || null;
                return _.isNull(period) ? 0: period.amount;
            }
        }
    }, {
        'field': 'offeredForYearCheckbox',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 3 }) || null;
                return !_.isNull(period);
            }
        }
    }, {
        'field': 'offeredForYearInput',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const pujaPeriods = _.get(data, 'pujaPeriods', []);
                const period = _.find(pujaPeriods, { period: 3 }) || null;
                return _.isNull(period) ? 0: period.amount;
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'count',
        'value': 1,
        'validators': []
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'additionalInfoSelect',
      'value': [],
      'validators': [],
      'options': {
        'setter': (data, value) => value || [],
        'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
      }
    }, {
      'field': 'additionalInfoSelectDesc',
      'value': '',
      'validators': [],
      'options': {
        'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
      }
    }]
};

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 3,
    'validators': [Validators.required]
})
clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [{
        'array': 'presetOptions',
        'schema': HinduTemplePujaPresetOptionSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'dontAllowAmountReduction',
        'value': false,
        'validators': []
    }, {
        'field': 'campaignLocationId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                if(data.campaignLocation) {
                    return data.campaignLocation._id;
                }
                return null;
            }
        }
    }, {
        'field': 'campaignLocation',
        'value': null,
        'validators': [Validators.required]
    }, {
        'field': 'deityList',
        'value': [],
        'validators': [],
        'options': {
        }
    }, {
        'field': 'sankalpDataNeeded',
        'value': false,
        'validators': []
    }, {
        'field': 'timeZone',
        'value': null,
        'validators': [Validators.required]
    }, {
        'field': 'addOnDonationCampaignRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.addOnDonationCampaignId) ? false: true
        }
    }, {
        'field': 'addOnDonationCampaignId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return _.isEmpty(control.value) ? "": control.value;
            }
        }
    }],
    'groups': [{
        'group': 'sankalpDataDisplay',
        'fields': [{
            'field': 'nakshtraDisplay',
            'value': '',
            'validators': [],
            'options': {
                'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
            }
        }, {
            'field': 'gotraDisplay',
            'value': '',
            'validators': [],
            'options': {
                'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
            }
        }, {
            'field': 'rasiDisplay',
            'value': '',
            'validators': [],
            'options': {
                'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
            }
        }]
    }]
}];
export const HinduTemplePujaSchema = clonedCampaignSchema;
